import "./activity.css";

const Activities = () => {
  return (
    <section id="activity">
      <h2 className="skillTitle">Extracurricular Activities</h2>
      <div className="activitiesList">
        <div className="activityCard">
          <h3>HackerEarth Technical Club</h3>
          <p>
            Served as President, leading weekly contests, workshops, and offline
            events that enhanced technical skills and teamwork.
          </p>
        </div>
        <div className="activityCard">
          <h3>Youth Red Cross (YRC)</h3>
          <p>
            Actively volunteered in blood donation camps, cleanliness drives,
            and community service activities.
          </p>
        </div>
        <div className="activityCard">
          <h3>Community & Events</h3>
          <p>
            Contributed to organizing and coordinating technical and social
            events fostering collaboration and learning.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Activities;
